import { render, staticRenderFns } from "./PlanSponsor.vue?vue&type=template&id=0f7d7653&"
import script from "./PlanSponsor.vue?vue&type=script&lang=js&"
export * from "./PlanSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports